// Utility functions and constants for zmanim calculation

export const ALL_ZMANIM = [
  { key: 'alot', label: 'עלות השחר' },
  { key: 'sunrise', label: 'הנץ החמה' },
  { key: 'sof_zman_shema_gra', label: 'סוף זמן קריאת שמע לגר"א' },
  { key: 'sof_zman_shema_mga', label: 'סוף זמן קריאת שמע למ"א' },
  { key: 'sof_zman_tefila_gra', label: 'סוף זמן תפילה לגר"א' },
  { key: 'sof_zman_tefila_mga', label: 'סוף זמן תפילה למ"א' },
  { key: 'chatzot', label: 'חצות היום' },
  { key: 'mincha_gedola', label: 'מנחה גדולה' },
  { key: 'mincha_ketana', label: 'מנחה קטנה' },
  { key: 'plag_hamincha', label: 'פלג המנחה' },
  { key: 'sunset', label: 'שקיעת החמה' },
  { key: 'tzeit', label: 'צאת הכוכבים' },
];

export const formatTime = (time: string) => {
  if (!time) return '--:--';
  let h = '', m = '';
  if (time.includes('T')) {
    const d = new Date(time);
    h = d.getHours().toString().padStart(2, '0');
    m = d.getMinutes().toString().padStart(2, '0');
  } else {
    [h, m] = time.split(':');
    h = h.padStart(2, '0');
    m = m.padStart(2, '0');
  }
  return `${h}:${m}`;
};

export const parseTime = (time: string) => {
  if (!time) return null;
  if (time.includes('T')) return new Date(time);
  const [h, m] = time.split(':');
  const now = new Date();
  now.setHours(Number(h), Number(m), 0, 0);
  return now;
};

export const addMinutes = (date: Date, minutes: number) => {
  const d = new Date(date);
  d.setMinutes(d.getMinutes() + minutes);
  return d;
};

export const formatDateToTime = (date: Date | null) => {
  if (!date) return '--:--';
  const h = date.getHours().toString().padStart(2, '0');
  const m = date.getMinutes().toString().padStart(2, '0');
  return `${h}:${m}`;
};

export const calculateZman = (key: string, zmanim: Record<string, string>) => {
  const sunrise = parseTime(zmanim['sunrise']);
  const sunset = parseTime(zmanim['sunset']);
  const alot = parseTime(zmanim['alot']);
  if (!sunrise || !sunset) return '--:--';
  const dayMinutes = (sunset.getTime() - sunrise.getTime()) / 60000;
  const shaahZmanit = dayMinutes / 12;
  switch (key) {
    case 'sof_zman_shema_gra':
      return formatDateToTime(addMinutes(sunrise, 3 * shaahZmanit));
    case 'sof_zman_tefila_gra':
      return formatDateToTime(addMinutes(sunrise, 4 * shaahZmanit));
    case 'sof_zman_shema_mga':
      if (!alot) return '--:--';
      return formatDateToTime(addMinutes(alot, 3 * shaahZmanit));
    case 'sof_zman_tefila_mga':
      if (!alot) return '--:--';
      return formatDateToTime(addMinutes(alot, 4 * shaahZmanit));
    case 'chatzot':
      return formatDateToTime(addMinutes(sunrise, 6 * shaahZmanit));
    case 'mincha_gedola':
      return formatDateToTime(addMinutes(sunrise, 6.5 * shaahZmanit));
    case 'mincha_ketana':
      return formatDateToTime(addMinutes(sunrise, 9.5 * shaahZmanit));
    case 'plag_hamincha':
      return formatDateToTime(addMinutes(sunrise, 10.75 * shaahZmanit));
    case 'alot':
      if (zmanim['alot'] && zmanim['alot'] !== '--:--') return zmanim['alot'];
      return formatDateToTime(addMinutes(sunrise, -72));
    case 'tzeit':
      if (zmanim['tzeit'] && zmanim['tzeit'] !== '--:--') return zmanim['tzeit'];
      return formatDateToTime(addMinutes(sunset, 22));
    default:
      return zmanim[key] || '--:--';
  }
}; 